<template>
  <div>
    <el-card class="mb5">
      <el-form :inline="false" label-position="top" size="small">
        <el-row :gutter="10">
          <el-col :span="6">
            <!--操作时间-->
            <el-form-item :label="$t('GlobalSetObj.operationTime')">
              <el-date-picker
                v-model="timeValue"
                :clearable="false"
                :default-time="['00:00:00', '23:59:59']"
                :format="$i18n.locale == 'zh' ? zhDate : ptDate"
                :placeholder="$t('newOrder.SelectDatetime')"
                range-separator="~"
                style="width: 100%"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="handleTime"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.operatorRegion')" prop="regionId">
              <el-select
                v-model="queryForm.params.regionId"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!--   操作人网点   -->
            <el-form-item :label="$t('GlobalSetObj.OperationSite')">
              <el-select
                v-model="queryForm.params.operationalUserSiteId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in opearateSitelist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('collectionCenter.operationType')">
              <el-select
                v-model="queryForm.params.operationTypeList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option :label="$t('GlobalSetObj.all')" value="" />
                <el-option
                  v-for="(item, index) in operationTypeOptList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 车牌号 -->
          <el-col :span="6">
            <el-form-item prop="selectType">
              <div class="selectLabel">
                <el-select
                  v-model="queryForm.params.queryType"
                  style="width: 130px"
                  @change="handleQueryType"
                >
                  <el-option key="1" :label="$t('GlobalSetObj.licensePlateNumber')" :value="1" />
                  <el-option key="2" :label="$t('GlobalSetObj.NIV')" :value="2" />
                </el-select>
              </div>
              <el-input
                v-model="numberList"
                :placeholder="$t('collectionCenter.max100Line')"
                :rows="1"
                clearable
                type="textarea"
                @blur="ft"
                @keydown.enter.native="BlockNewNumberline"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <!--搜索-->
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--高级搜索-->
            <el-button size="small" type="primary" @click="advancedSearch">
              {{ $t('home.advancedSearch') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm"
            >{{ $t('newOrder.reset') }}
            </el-button>
            <el-button
              icon="el-icon-upload2"
              size="small"
              style="margin-bottom: 10px"
              @click="allExportOrder"
            >{{ $t('newOrder.export') }}
            </el-button>
            <!--批量单号导出-->
            <el-button size="small" type="primary" @click="clickBtchExport">{{ $t('placeOrder.BatchExport') }}
            </el-button>
            <el-radio-group
              v-model="isTest"
              v-permitBtn:remove="'btn:SortingCenter:outGoRecordData'"
              size="small"
              style="margin-left: 10px"
              @change="handleTest"
            >
              <el-radio-button :label="1">{{ $t('newOrder.Formal') }}</el-radio-button>
              <el-radio-button :label="0">{{ $t('newOrder.test1') }}</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-form>
      <!-- 已选条件 -->
      <div v-if="getSelectedConditions().length" class="selected-conditions">
        <span class="selected-label">
          <i class="el-icon-filter" />
          {{ $t('seller.selectedConditions') }}:
        </span>
        <el-tag
          v-for="item in getSelectedConditions()"
          :key="item.key"
          class="selected-tag"
          closable
          size="medium"
          @close="removeCondition(item.key)"
        >
          {{ item.label }}: {{ item.value }}
        </el-tag>
        <el-button class="clear-all-btn" type="text" @click="clearAllConditions">
          <i class="el-icon-delete" />
          {{ $t('seller.clearAll') }}
        </el-button>
      </div>
    </el-card>
    <!--  表格数据  -->
    <el-card>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        style="width: 100%"
      >
        <el-table-column
          :label="`${$t('GlobalSetObj.serial', 'zh')}（${$t('GlobalSetObj.serial', 'pu')}）`"
          align="center"
          type="index"
          width="80"
        />
        <!--到场袋号-->
        <el-table-column
          :label="`${$t('GlobalSetObj.ArrivalBagNumber', 'zh')}（${$t(
            'GlobalSetObj.ArrivalBagNumber',
            'pu'
          )}）`"
          min-width="130"
          prop="bagNumber"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.bagNumber || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="`${$t('newOrder.waybillNumber', 'zh')}（${$t('newOrder.waybillNumber', 'pu')}）`"
          min-width="160"
          prop="waybillNumber"
        >
          <template slot-scope="scope">
            <div>
              <el-popover placement="top" popper-class="copy" trigger="hover">
                <el-button
                  style="color: black; font-size: 12px; padding: 2px"
                  type="text"
                  @click="copy(scope.row.waybillNumber)"
                >{{ `${$t('orderDetails.copy', 'zh')}（${$t('orderDetails.copy', 'pu')}）` }}
                </el-button>
                <div slot="reference" class="WaybillNumber" @click="toOrderDetail(scope.row)">
                  {{ scope.row.waybillNumber || '--' }}
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :label="`${$t('GlobalSetObj.ScanNumber', 'zh')}（${$t(
            'GlobalSetObj.ScanNumber',
            'pu'
          )}）`"
          min-width="160"
          prop="scanOrderNumber"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.scanOrderNumber || '--' }}</div>
          </template>
        </el-table-column>

        <!-- 客户 -->
        <el-table-column
          :label="`${$t('GlobalSetObj.client', 'zh')}（${$t('GlobalSetObj.client', 'pu')}）`"
          min-width="120"
          prop="customerName"
        />

        <el-table-column
          :label="`${$t('newOrder.waybillStatus', 'zh')}（${$t('newOrder.waybillStatus', 'pu')}）`"
          min-width="160"
          prop="waybillStatusName"
        />
        <!--   最新轨迹时间   -->
        <el-table-column
          :label="`${$t('orderCenterCont.TheLatestTraceTime', 'zh')}（${$t(
            'orderCenterCont.TheLatestTraceTime',
            'pu'
          )}）`"
          min-width="160"
          prop="lastTrackTime"
        />
        <!--   最新轨迹内容   -->
        <el-table-column
          :label="`${$t('orderCenterCont.zuixinguijineir', 'zh')}（${$t(
            'orderCenterCont.zuixinguijineir',
            'pu'
          )}）`"
          min-width="160"
          prop="lastTrackDescribe"
        />
        <el-table-column
          :label="`${$t('collectionCenter.operationType', 'zh')}（${$t(
            'collectionCenter.operationType',
            'pu'
          )}）`"
          align="center"
          min-width="150"
          prop="operationTypeName"
        />
        <!-- 操作备注 -->
        <el-table-column
          align="center"
          label="操作备注（Observações da operação）"
          min-width="150"
          prop="operationRemark"
        />
        <el-table-column
          :label="`${$t('GlobalSetObj.operationTime', 'zh')}（${$t(
            'GlobalSetObj.operationTime',
            'pu'
          )}）`"
          min-width="170"
          prop="operateTime"
        />
        <!--本场地集包-->
        <el-table-column
          :label="`${$t('routes.ThisAreaCollectsPackages', 'zh')}（${$t(
            'routes.ThisAreaCollectsPackages',
            'pu'
          )}）`"
          min-width="170"
          prop="thisBagNumber"
        />
        <!--集包时间-->
        <el-table-column
          :label="`${$t('routes.CollectionTime', 'zh')}（${$t('routes.CollectionTime', 'pu')}）`"
          min-width="170"
          prop="packetTime"
        />
        <!--预测下一站-->
        <el-table-column
          :label="`${$t('routes.PredictNextStop', 'zh')}（${$t('routes.PredictNextStop', 'pu')}）`"
          min-width="170"
          prop="preNextSiteName"
        />
        <el-table-column
          :label="`${$t('GlobalSetObj.nextStation', 'zh')}（${$t(
            'GlobalSetObj.nextStation',
            'pu'
          )}）`"
          min-width="170"
          prop="nextSiteName"
        />
        <el-table-column
          :label="`${$t('GlobalSetObj.licensePlateNumber', 'zh')}（${$t(
            'GlobalSetObj.licensePlateNumber',
            'pu'
          )}）`"
          min-width="160"
          prop="vehicleNumber"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.vehicleNumber || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="`${$t('GlobalSetObj.NIV', 'zh')}（${$t('GlobalSetObj.NIV', 'pu')}）`"
          min-width="140"
          prop="vehicleTagNumber"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.vehicleTagNumber || '-' }}</div>
          </template>
        </el-table-column>
        <!-- 州  -->
        <el-table-column
          :label="`${$t('newOrder.RecipientState', 'zh')}（${$t(
            'newOrder.RecipientState',
            'pu'
          )}）`"
          min-width="120"
          prop="preState"
        />
        <el-table-column
          :label="`${$t('GlobalSetObj.preEntrega', 'zh')}（${$t(
            'GlobalSetObj.preEntrega',
            'pu'
          )}）`"
          min-width="160"
          prop="preDeliverSiteName"
        />
        <el-table-column
          label="操作人大区（Região do operador）"
          min-width="100"
          prop="regionName"
        />
        <el-table-column
          :label="`${$t('GlobalSetObj.OperationState', 'zh')}（${$t(
            'GlobalSetObj.OperationState',
            'pu'
          )}）`"
          min-width="100"
          prop="operateUserState"
        />
        <el-table-column
          :label="`${$t('GlobalSetObj.OperationSite', 'zh')}（${$t(
            'GlobalSetObj.OperationSite',
            'pu'
          )}）`"
          min-width="120"
          prop="operateSiteName"
        />
        <el-table-column
          :label="`${$t('GlobalSetObj.operator', 'zh')}（${$t('GlobalSetObj.operator', 'pu')}）`"
          min-width="150"
          prop="operateUserName"
        />
      </el-table>
      <!--  分页  -->
      <el-pagination
        :current-page="queryForm.number"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 10px 0; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!--详情-->
    <el-drawer
      :append-to-body="true"
      :title="$t('orderDetails.waybillMsg')"
      :visible.sync="waybillDescription"
      custom-class="drawerClass"
      direction="ltr"
      size="80%"
    >
      <div style="height: calc(100vh - 67px); overflow: auto">
        <detailPage :key="detailKey" :query-track-param="queryTrackParam" query-type="1" />
      </div>
    </el-drawer>
    <!--  批量单号导出  -->
    <el-dialog
      :append-to-body="true"
      :close-on-click-modal="false"
      :show-close="true"
      :title="$t('placeOrder.BatchExport')"
      :visible.sync="dialogVisibleExport"
      top="10vh"
      width="500px"
      @close="clearForm"
    >
      <el-form
        ref="exportRuleForm"
        :model="exportRuleForm"
        class="demo-exportRuleForm"
        label-position="top"
      >
        <el-form-item
          :rules="{
            required: true,
            message: $t('placeOrder.pleaseInput'),
            trigger: ['blur', 'change']
          }"
          prop="NumberType"
        >
          <el-select v-model="exportRuleForm.NumberType" style="width: 80%">
            <!--运单号-->
            <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" value="1" />
            <!--单号-->
            <el-option key="5" :label="$t('GlobalSetObj.ScanNumber')" value="5" />
          </el-select>
        </el-form-item>
        <el-form-item
          :rules="{
            required: true,
            message: $t('placeOrder.pleaseInput'),
            trigger: ['blur']
          }"
          prop="inputValeu"
          style="width: 100%"
        >
          <el-input
            v-model="exportRuleForm.inputValeu"
            :placeholder="$t('orderCenterCont.Multiple')"
            clearable
            rows="6"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin: 15px 0">
        <el-button size="small" @click="dialogVisibleExport = false">{{ $t('GlobalSetObj.Cancelar') }}
        </el-button>
        <el-button size="small" type="primary" @click="comfireBtchExport">{{ $t('collectionCenter.CheckItOutNow') }}
        </el-button>
      </div>
    </el-dialog>
    <!--  高级搜索  -->
    <search-com
      ref="searchComRef"
      :site-list="siteList"
      :state-options="StateList"
      :state-value="queryForm.params.operationalUserState"
      :waybill-status-list="waybillStatusList"
      @search="advancedSearchEvent"
      @update:stateValue="handleStateValueChange"
    />
  </div>
</template>

<script>
import {
  getLgAreaListData,
  regionQueryList,
  selectInfoByStateTwo,
  selectSiteByState,
  shipmentExportAll,
  shipmentPage
} from '@/api/orderApi';
import detailPage from '@/components/detailComponent/detailPage.vue';
import { getAllStartSite, shipmentexportAll } from '@/api/logisticsOrders';
import { copyData } from '@/utils/copyData';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash-es';
import { waybillStatusList } from '@/utils/enumData';
import { goResourceTaskList } from '@/utils/goExportList';
import { Loading } from 'element-ui';
import searchCom from './cmp/searchCom.vue';

const PARAMS = {
  inputValue: '',
  nextSiteIds: [],
  preDeliverySiteId: '',
  operateUserName: '',
  selectType: 1,
  operationTypeList: [],
  preDeliverySiteState: [],
  operationalUserState: [],
  operationalUserSiteId: '',
  waybillStatus: [],
  queryType: 1,
  numberList: [],
  customerIdList: [], // 客户
  regionId: null
};

export default {
  name: 'OutGoRecord',
  components: {
    detailPage,
    searchCom
  },
  data() {
    return {
      numberList: '',
      notEnter: true, // 是否允许换行
      allSiteListCache: null, // 全部网点数据缓存
      sitesByRegionAndState: {},
      regionList: [],
      // 详情
      waybillDescription: false,
      detailKey: new Date().getTime(),
      queryTrackParam: {},
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        number: 1,
        total: 0,
        params: cloneDeep(PARAMS)
      },
      siteList: [], // 网点
      tableData: [],
      userList: [], // 用户列表
      customerNameMap: {}, // 客户 id -> 名称映射（用于已选条件展示）
      StateList: [], // 州
      preDeliverySiteList: [],
      isTest: 1,
      waybillStatusList: waybillStatusList,
      dialogVisibleExport: false,
      exportRuleForm: {
        NumberType: '1',
        inputValeu: ''
      },
      opearateSitelist: [],
      operationTypeOptList: [
        { label: this.$t('GlobalSetObj.sender'), value: 1 },
        { label: this.$t('GlobalSetObj.arrive'), value: 2 },
        { label: this.$t('collectionCenter.truckLoading'), value: 3 },
        { label: this.$t('collectionCenter.unloading'), value: 4 },
        { label: this.$t('collectionCenter.consolidateCode'), value: 13 },
        { label: this.$t('collectionCenter.collect'), value: 5 },
        { label: this.$t('collectionCenter.networkEntry'), value: 6 },
        { label: this.$t('spareNumberPoo.branchDelivery'), value: 7 },
        { label: this.$t('collectionCenter.signFor'), value: 8 },
        { label: this.$t('GlobalSetObj.returnWarehouseShipment'), value: 9 },
        { label: this.$t('GlobalSetObj.returnWarehouseReceive'), value: 10 },
        { label: this.$t('GlobalSetObj.reverseDispatch'), value: 11 },
        { label: this.$t('GlobalSetObj.reverseSign'), value: 12 }
      ]
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '190px' : '120px'
      };
    }
  },
  watch: {
    'queryForm.params.regionId'(val) {
      this.queryForm.params.operationalUserState = [];
      this.queryForm.params.operationalUserSiteId = '';
      if (val && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === val);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.StateList = selectedRegion.states.map((label) => ({ label }));
        }
        this.opearateSitelist = selectedRegion?.sites || [];
        this.groupSitesByRegionAndState();
      } else {
        this.StateList = [];
        this.getAddress();
      }
      if (!val) {
        this.opearateSitelist = [];
      }
    },
    'queryForm.params.operationalUserState'(newVal) {
      const regionId = this.queryForm.params.regionId;
      if (regionId) {
        this.queryForm.params.operationalUserSiteId = '';
      }

      if (!regionId && newVal) {
        if (this.allSiteListCache) {
          this.opearateSitelist = this.allSiteListCache;
        }
        return;
      }

      // 如果没有选择州，则显示当前大区下的所有网点
      if (regionId && (!newVal || newVal.length <= 0)) {
        const selectedRegion = this.regionList.find((r) => r.id === regionId);
        this.opearateSitelist = selectedRegion?.sites || [];
      }
      if (regionId && newVal && newVal.length > 0) {
        let combinedSites = [];
        newVal.forEach((state) => {
          const sites = this.sitesByRegionAndState[regionId]?.[state] || [];
          combinedSites = [...combinedSites, ...sites];
        });
        this.opearateSitelist = combinedSites;
      }
    },
    numberList(val) {
      this.processNumberList(val);
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getAddress();
    this.getAllSite();
    this.getOperationState();
    this.getSearch(1);
    this.getRegion();
    this.getOperationName('');
  },
  methods: {
    processNumberList(val) {
      if (!val) {
        this.queryForm.params.numberList = [];
        this.notEnter = true;
        return;
      }
      const processedLines = val
        .split('\n')
        .filter((line) => line && line.trim())
        .map((line) => line.replace(/\s/g, '').trim());
      if (processedLines.length > 100) {
        this.numberList = processedLines.slice(0, 100).join('\n');
        this.queryForm.params.numberList = processedLines.slice(0, 100);
        this.notEnter = false;
        this.$message.warning(this.$t('collectionCenter.intercept100'));
      } else {
        this.queryForm.params.numberList = processedLines;
        this.notEnter = true;
      }
    },
    ft() {
      this.processNumberList(this.numberList);
    },
    BlockNewNumberline() {
      const e = window.event || arguments[0];
      this.processNumberList(this.numberList);
      if (!this.notEnter) {
        event.preventDefault();
        e.returnValue = false;
        return true;
      }
    },
    // 大区
    getRegion() {
      regionQueryList(2).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    groupSitesByRegionAndState() {
      const grouped = {};
      this.regionList.forEach((region) => {
        if (!grouped[region.id]) {
          grouped[region.id] = {};
        }

        region.sites.forEach((site) => {
          const key = site.state; // 区分大小写
          if (!grouped[region.id][key]) {
            grouped[region.id][key] = [];
          }
          grouped[region.id][key].push(site);
        });
      });

      this.sitesByRegionAndState = grouped;
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    enterSearch() {
      this.queryForm.number = 1;
      this.getSearch();
    },
    // 打开高级搜索弹窗
    advancedSearch() {
      this.$refs.searchComRef.showDialog();
    },
    // 高级搜索查询
    advancedSearchEvent({ params, userList, customerNameMap }) {
      if (userList && userList.length > 0) {
        this.userList = userList;
      }
      if (customerNameMap) {
        this.customerNameMap = customerNameMap;
      }
      Object.assign(this.queryForm.params, params);
      this.queryForm.number = 1;
      this.getSearch();
    },
    handleStateValueChange(val) {
      this.queryForm.params.operationalUserState = val;
    },
    // 重置
    resetForm() {
      this.queryForm.number = 1;
      this.isTest = 1;
      this.getTimer();
      this.queryForm.params = cloneDeep(PARAMS);
      // 同步重置高级搜索内的查询条件
      if (this.$refs.searchComRef) {
        this.$refs.searchComRef.handleReset();
      }
      this.handleQueryType();
      this.getSearch();
      this.getOperationName('');
    },
    handleTest() {
      this.queryForm.number = 1;
      this.getSearch();
    },
    allExportOrder() {
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue.split('\n');
        if (inputValList.length > 2000) {
          this.$message.warning(this.$t('newOrder.searchMax1000'));
          inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
        }
      }
      const data = {};
      if (this.timeValue && this.timeValue.length > 0) {
        data.operateTimeStart = this.timeValue[0];
        data.operateTimeEnd = this.timeValue[1];
      } else {
        if (!this.numberList) {
          this.$message.warning(this.$t('GlobalSetObj.selectTime'));
          return;
        }
      }
      if (this.queryForm.params.selectType === 1) {
        data.waybillNumber = inputValList;
      } else if (this.queryForm.params.selectType === 2) {
        data.bagNumber = inputValList;
      } else {
        data.scanNumber = inputValList;
      }
      // data.params.waybillNumber = inputValList;
      data.nextSiteIds = this.queryForm.params.nextSiteIds;
      data.operationalUserSiteId = this.queryForm.params.operationalUserSiteId;
      data.preDeliverySiteId = this.queryForm.params.preDeliverySiteId;
      const obj = this.userList.find((item) => {
        return item.keyId === this.queryForm.params.operateUserName;
      });
      if (obj) {
        if (obj.expressId) {
          data.expressId = obj.expressId;
          data.supplierId = null;
        } else {
          data.supplierId = obj.supplierId;
          data.expressId = null;
        }
      }
      data.preDeliverySiteState = this.queryForm.params.preDeliverySiteState;
      data.operationalUserState = this.queryForm.params.operationalUserState;
      data.isTest = this.isTest;
      data.waybillStatus = this.queryForm.params.waybillStatus;
      data.queryType = this.queryForm.params.queryType;
      data.numberList = this.queryForm.params.numberList;
      data.operationTypeList = this.queryForm.params.operationTypeList.includes('')
        ? []
        : this.queryForm.params.operationTypeList;
      data.regionId = this.queryForm.params.regionId;
      shipmentExportAll(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 查询
    getSearch(val) {
      // 同步高级搜索内未提交的查询条件（未点"搜索"直接关闭也能生效）
      if (this.$refs.searchComRef && this.$refs.searchComRef.getLocalParams) {
        const { params, userList, customerNameMap } = this.$refs.searchComRef.getLocalParams();
        Object.assign(this.queryForm.params, params);
        if (userList && userList.length > 0) {
          this.userList = userList;
        }
        if (customerNameMap) {
          this.customerNameMap = customerNameMap;
        }
      }
      let inputValList = [];
      if (this.queryForm.params.inputValue) {
        inputValList = this.queryForm.params.inputValue.split('\n');
      }
      if (inputValList.length > 2000) {
        this.$message.warning(this.$t('newOrder.searchMax1000'));
        inputValList = inputValList.slice(0, 2000); // 截取前2000个单号
      }
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.number;
      if (this.timeValue && this.timeValue.length > 0) {
        data.params.operateTimeStart = this.timeValue[0];
        data.params.operateTimeEnd = this.timeValue[1];
      } else {
        if (!this.numberList) {
          this.$message.warning(this.$t('GlobalSetObj.selectTime'));
          return;
        }
      }
      if (this.queryForm.params.selectType === 1) {
        data.params.waybillNumber = inputValList;
      } else if (this.queryForm.params.selectType === 2) {
        data.params.bagNumber = inputValList;
      } else {
        data.params.scanNumber = inputValList;
      }
      data.params.nextSiteIds = this.queryForm.params.nextSiteIds;
      data.params.operationalUserSiteId = this.queryForm.params.operationalUserSiteId;
      data.params.preDeliverySiteId = this.queryForm.params.preDeliverySiteId;
      const obj = this.userList.find((item) => {
        return item.keyId === this.queryForm.params.operateUserName;
      });
      if (obj) {
        if (obj.expressId) {
          data.params.expressId = obj.expressId;
          data.params.supplierId = null;
        } else {
          data.params.supplierId = obj.supplierId;
          data.params.expressId = null;
        }
      }
      // console.log(obj, 'objobjobj');
      data.params.preDeliverySiteState = this.queryForm.params.preDeliverySiteState;
      data.params.operationalUserState = this.queryForm.params.operationalUserState;
      data.params.isTest = this.isTest;
      let statusList = [];
      if (this.queryForm.params.waybillStatus.includes(3)) {
        statusList = cloneDeep(this.queryForm.params.waybillStatus);
        if (!statusList.includes(19)) {
          statusList.push(19);
        }
      } else {
        statusList = this.queryForm.params.waybillStatus;
      }
      data.params.waybillStatus = statusList;
      data.params.queryType = this.queryForm.params.queryType;
      data.params.numberList = this.queryForm.params.numberList;
      data.params.operationTypeList = this.queryForm.params.operationTypeList.includes('')
        ? []
        : this.queryForm.params.operationTypeList;
      data.params.customerIdList = this.queryForm.params.customerIdList;
      data.params.regionId = this.queryForm.params.regionId;

      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      shipmentPage(data)
        .then((res) => {
          if (res.code === 200) {
            this.queryForm.total = res.data.total;
            // this.tableData = res.data.records;
            this.tableData = Object.freeze(
              (res.data.records || []).map((item) => {
                const obj = {
                  ...item
                };

                // if (waybillStatusObj[item.waybillStatus].label) {
                //   obj.statusNamewaybill = waybillStatusObj[item.waybillStatus].label;
                // }

                return obj;
              })
            );
            if (val === 1) {
              loading.close();
            }
            // console.log(this.tableData, 'tableData');
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
    },
    // 批量导出
    clickBtchExport() {
      this.dialogVisibleExport = true;
    },
    clearForm() {
      this.exportRuleForm.NumberType = '1';
      this.exportRuleForm.inputValeu = '';
    },
    // 确定批量导出
    comfireBtchExport() {
      this.$refs['exportRuleForm'].validate((valid) => {
        if (valid) {
          const numList = this.exportRuleForm.inputValeu
            ? this.exportRuleForm.inputValeu.split('\n')
            : [];
          const filteredArray = numList.filter((item) => /\S/.test(item));
          if (filteredArray.length === 0) {
            this.$message.error(this.$t('GlobalSetObj.notMore10wTip'));
            return;
          }
          if (filteredArray.length > 100000) {
            this.$message.error(this.$t('GlobalSetObj.notMore10w'));
            return;
          }
          const data = {};
          if (this.exportRuleForm.NumberType === '1') {
            data.waybillNumberList = filteredArray;
            data.scanOrderNumberList = [];
          } else {
            data.waybillNumberList = [];
            data.scanOrderNumberList = filteredArray;
          }
          this.dialogVisibleExport = false;
          shipmentexportAll(data).then((res) => {
            if (res.code === 200) {
              goResourceTaskList();
            }
          });
        } else {
          return false;
        }
      });
    },
    handleQueryType() {
      this.queryForm.params.numberList = [];
      this.numberList = '';
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.number = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      console.log('handleCurrentChange', val);
      this.queryForm.number = val;
      this.getSearch();
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      // const oneWeekAgo = dayjs(brazilTime).subtract(1, 'week').format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
    },
    handleTime(val) {
      if (val) {
        const startDate = dayjs(val[0]);
        const endDate = dayjs(val[1]);
        // 计算天数差（取绝对值，确保顺序不影响结果）
        const daysDiff = Math.abs(endDate.diff(startDate, 'day'));
        // 判断是否超过31天
        const isOver31Days = daysDiff > 31;
        if (isOver31Days) {
          this.$message.error(this.$t('tablePrice.timeRangeLimit'));
          this.getTimer();
        }
      }
    },
    // 获取所有网点
    getAllSite() {
      this.siteList = [];
      getAllStartSite().then((res) => {
        if (res.code === 200) {
          console.log('获取所有网点', res.data);
          this.siteList = res.data;
          this.preDeliverySiteList = this.siteList;
        }
      });
    },
    // 进入运单详情
    toOrderDetail(row) {
      this.queryTrackParam = row;
      console.log(row, ':query-track-param="queryTrackParam"');
      console.log(
        row.waybillId,
        'row.waybillIdrow.waybillIdrow.waybillId',
        this.queryTrackParam.waybillId
      );
      this.waybillDescription = true;
      this.detailKey = new Date().getTime();
      setTimeout(() => {
        this.bus.$emit('todetailBox', row.waybillId);
      }, 100);
    },
    handlepreDeliverySiteState(val) {
      this.queryForm.params.preDeliverySiteId = '';
      if (val && val.length > 0) {
        selectSiteByState(val).then((res) => {
          if (res.status === 'OK') {
            console.log('获取所有网点', res.data);
            this.preDeliverySiteList = res.data;
          }
        });
      } else {
        this.preDeliverySiteList = this.siteList;
      }
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    // 州
    getOperationState(falg, val) {
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const data = {};
      if (falg === 1) {
        data.state = val;
        this.queryForm.params.operationalUserSiteId = '';
        this.queryForm.params.operateUserName = '';
      } else if (falg === 2) {
        data.siteId = val;
        this.queryForm.params.operateUserName = '';
      } else if (falg === 3) {
        data.operateUserName = val;
      }
      selectInfoByStateTwo(data)
        .then((res) => {
          if (res.code === 200) {
            this.opearateSitelist = res.data.siteList;
            this.userList = res.data.userList;
            load.close();
          }
        })
        .finally(() => {
          load.close();
        });
    },
    getOperationName(val) {
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const data = {};
      data.operateUserName = val;
      selectInfoByStateTwo(data)
        .then((res) => {
          if (res.code === 200) {
            this.allSiteListCache = res.data.siteList; // 缓存全部网点
            this.opearateSitelist = [...this.allSiteListCache]; // 初始化为全量数据
            this.userList = res.data.userList;
            load.close();
          }
        })
        .finally(() => {
          load.close();
        });
    },
    selectStatus(val) {
      if (val.indexOf(0) !== -1) {
        this.queryForm.params.waybillStatus = [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22
        ];
      }
    },
    // 已选条件展示数据（仅展示高级搜索抽屉内的条件）
    getSelectedConditions() {
      const list = [];
      const params = this.queryForm.params;

      // 操作人州：高级搜索项，选中值通过 update:stateValue 同步回父组件
      if (params.operationalUserState && params.operationalUserState.length) {
        list.push({
          key: 'operationalUserState',
          label: this.$t('GlobalSetObj.OperationState'),
          value: params.operationalUserState.join(', ')
        });
      }

      const ref = this.$refs.searchComRef;
      if (ref && ref.localParams) {
        const sp = ref.localParams;

        if (sp.inputValue) {
          const typeMap = {
            1: this.$t('newOrder.waybillNumber'),
            3: this.$t('GlobalSetObj.ScanNumber'),
            2: this.$t('GlobalSetObj.bagNumber')
          };
          const typeName = typeMap[sp.selectType] || '';
          const vals = sp.inputValue
            .split('\n')
            .filter((s) => s.trim())
            .map((s) => s.replace(/\s/g, '').trim());
          if (vals.length) {
            list.push({ key: 'inputValue', label: typeName, value: vals.join(', ') });
          }
        }

        if (sp.operateUserName) {
          const u = this.userList.find((item) => item.keyId === sp.operateUserName);
          list.push({
            key: 'operateUserName',
            label: this.$t('GlobalSetObj.operator'),
            value: u ? u.operateUserName : sp.operateUserName
          });
        }

        if (sp.preDeliverySiteState && sp.preDeliverySiteState.length) {
          list.push({
            key: 'preDeliverySiteState',
            label: this.$t('newOrder.RecipientState'),
            value: sp.preDeliverySiteState.join(', ')
          });
        }

        if (sp.preDeliverySiteId) {
          const list2 = ref.preDeliverySiteList || [];
          const s = list2.find((item) => item.id === sp.preDeliverySiteId);
          list.push({
            key: 'preDeliverySiteId',
            label: this.$t('GlobalSetObj.preEntrega'),
            value: s ? s.name : sp.preDeliverySiteId
          });
        }

        if (sp.nextSiteIds && sp.nextSiteIds.length) {
          const names = sp.nextSiteIds.map((id) => {
            const s = this.siteList.find((item) => item.id === id);
            return s ? s.name : id;
          });
          list.push({
            key: 'nextSiteIds',
            label: this.$t('GlobalSetObj.nextStation'),
            value: names.join(', ')
          });
        }

        if (sp.waybillStatus && sp.waybillStatus.length) {
          const names = sp.waybillStatus.map((code) => {
            const w = this.waybillStatusList.find((item) => item.code === code);
            return w ? w.label : code;
          });
          list.push({
            key: 'waybillStatus',
            label: this.$t('newOrder.waybillStatus'),
            value: names.join(', ')
          });
        }

        if (sp.customerIdList && sp.customerIdList.length) {
          const names = sp.customerIdList.map((id) => this.customerNameMap[id] || id);
          list.push({
            key: 'customerIdList',
            label: this.$t('GlobalSetObj.client'),
            value: names.join(', ')
          });
        }
      }

      return list;
    },
    // 移除单个已选条件
    removeCondition(key) {
      const params = this.queryForm.params;
      const ref = this.$refs.searchComRef;
      const sp = ref && ref.localParams;
      switch (key) {
        case 'operationalUserState':
          params.operationalUserState = [];
          if (ref) ref.$emit('update:stateValue', []);
          break;
        case 'inputValue':
          if (sp) {
            sp.selectType = 1;
            sp.inputValue = '';
          }
          break;
        case 'operateUserName':
          if (sp) sp.operateUserName = '';
          break;
        case 'preDeliverySiteState':
          if (sp) sp.preDeliverySiteState = [];
          break;
        case 'preDeliverySiteId':
          if (sp) sp.preDeliverySiteId = '';
          break;
        case 'nextSiteIds':
          if (sp) sp.nextSiteIds = [];
          break;
        case 'waybillStatus':
          if (sp) sp.waybillStatus = [];
          break;
        case 'customerIdList':
          if (sp) sp.customerIdList = [];
          break;
        default:
          break;
      }
      this.queryForm.number = 1;
      this.getSearch();
    },
    // 清空全部已选条件
    clearAllConditions() {
      this.resetForm();
    }
  }
};
</script>

<style scoped>
.app-container >>> .drawerClass header {
  border-bottom: 1px solid #ccc !important;
  margin-bottom: 0 !important;
  padding: 20px 20px 20px !important;
}

.app-container >>> .el-form--label-top .el-form-item__label {
  width: 100% !important;
}

.app-container >>> .selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}

.app-container >>> .selectLabel .el-input__icon {
  line-height: 28px !important;
}

.selectLabel {
  display: flex;
  align-items: center;
}

.selectLabel ::v-deep .el-input {
  height: 28px !important;
}

.selectLabel ::v-deep .el-input__inner {
  border: none;
  box-shadow: none;
  color: #606266;
  font-size: 14px;
  background: transparent;
  padding: 0;
  text-align: left;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px;
}

.selectType ::v-deep.el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.WaybillNumber {
  color: #00a551;
  cursor: pointer;
  padding: 0;
}

.selected-conditions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-top: 5px;
  gap: 8px;
}

.selected-conditions .selected-label {
  font-weight: bold;
  color: #303133;
  margin-right: 4px;
}

.selected-conditions .selected-tag {
  background: #f4f4f5;
  border-color: #e9e9eb;
  color: #606266;
}

.selected-conditions .clear-all-btn {
  margin-left: auto;
  color: #67c23a;
}

.selected-conditions .clear-all-btn:hover {
  color: #85ce61;
}
</style>
